import { UI } from 'common';
import React from 'react';

const { WrappedInputTextWithLabel, WrappedCheckbox } = UI;

class ListFilter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: '',
		};
	}

	listenCheckAll = () => {
		const { tabInfo, filterData } = this.props;
		const { searchValue } = this.state;
		const searchedData = tabInfo.data.filter(
			item => item.Name.indexOf(searchValue) !== -1
		);

		return searchedData.length > 0 && searchedData.length === filterData.length;
	};

	/**
	 * CheckAll handler
	 * if checked => set filter data = all current data (need to check search value)
	 * else set = empty array
	 */
	handleFilterCheckAllChange = e => {
		const { searchValue } = this.state;
		const { setFilterData, tabInfo } = this.props;
		const newFilterData = e.target.checked
			? tabInfo.data
					.filter(item => item.Name.indexOf(searchValue) !== -1)
					.map(info => info.Name)
			: [];

		setFilterData({
			[tabInfo.name]: newFilterData,
		});
	};

	handleFilterInputChange = e => {
		if (e.keyCode === 13) {
			this.setState({
				searchValue: e.target.value,
			});
		}
	};

	render() {
		const { tabInfo, filterData, handleSelectCheckbox } = this.props;
		const { searchValue } = this.state;
		const isCheckAll = this.listenCheckAll();

		return (
			<div>
				<div className="search-filter">
					<div className="input-search-container">
						<WrappedInputTextWithLabel
							uiElementConfig={{
								type: 'text',
								name: tabInfo.name,
								onKeyUp: this.handleFilterInputChange,
								placeholder: `Search ${tabInfo.name}`,
								dataqa: `input-search-filter-${tabInfo.name}`,
							}}
						/>
						<i className="pi pi-search" />
					</div>
					<div className="filter-checkbox">
						<WrappedCheckbox
							name={tabInfo.name}
							value={isCheckAll}
							onChange={this.handleFilterCheckAllChange}
							checked={isCheckAll}
							dataqa={`selected-all-${tabInfo.name}`}
						>
							All {tabInfo.name}
						</WrappedCheckbox>
					</div>
				</div>
				{tabInfo.data.map((item, index) => {
					if (!new RegExp(searchValue, 'i').test(item.Name)) {
						return;
					}
					return (
						<div className="filter-checkbox" key={index}>
							<WrappedCheckbox
								name={tabInfo.name}
								value={item.Name}
								onChange={handleSelectCheckbox}
								checked={filterData && filterData.includes(item.Name)}
								dataqa={`selected-${item.Name && item.Name.replace(/\s/g, '')}-${
									tabInfo.name
								}`}
							>
								{item.Name}
							</WrappedCheckbox>
						</div>
					);
				})}
			</div>
		);
	}
}

export default ListFilter;
